export default defineNuxtPlugin(async () => {
    const authUser = useAuthUser();
    const userCookie = useCookie<string | null>('__dds_demo_user');
    const roleCookie = useCookie<string | null>('__dds_demo_role');

    // If we have a demo cookie, restore the auth state
    if (userCookie.value) {
        try {
            const { data } = await $fetch<{ success: boolean; data: { id: string; email: string; firstName: string; lastName: string; role: string; clientId: string | null; techType: string | null } }>('/api/demo/role', {
                method: 'POST',
                body: { userId: userCookie.value }
            });

            authUser.value = { id: data.id, email: data.email };

            // Restore demo user state
            const demoUserState = useState('demo-user');
            demoUserState.value = data;
        } catch {
            // Cookie is stale — clear it
            userCookie.value = null;
            roleCookie.value = null;
        }
    }
});
